import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';
import { deleteUser } from 'utils/api';
import { toast } from 'react-toastify';
import SpinnerButton from 'components/SpinnerButton';

const DeleteUserModal = ({ isOpen, toggle, user, refreshList }) => {
    const [deleting, setDeleting] = useState(false);

    const onConfirm = async () => {
        try {
            setDeleting(true);
            await deleteUser(user.id);
            toast.success('User successfully deleted');
            //await getList();
            await refreshList(true);
            toggle();
        } catch (err) {
            setDeleting(false);
            if(err.message && err.message.length < 150) {
                toast.error(err.message);
            } else {
                toast.error('Unable to complete your request at this time');
            }
            console.log(err);
        }
    };

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader toggle={toggle}>
                <strong>Delete this user?</strong>
            </ModalHeader>
            <ModalBody>
                <div style={{ paddingRight: 25 }}>
                    Are you sure you want to delete {user.name}?
                </div>
            </ModalBody>
            <ModalFooter className="select-fetches-modal-footer">
                <Button style={{ color: 'white' }} onClick={toggle}>
                    Cancel
                </Button>
                <SpinnerButton
                    minWidth="85px"
                    onClick={onConfirm}
                    title="Confirm"
                    submitting={deleting}
                />
                {/*{deleteLoading ?*/}
                {/*    <div className="flex-centered" style={{ width: '85px', height: '100%' }}>*/}
                {/*        <i className="fa fa-spinner fa-spin" />*/}
                {/*    </div>*/}
                {/*    :*/}
                {/*    <Button */}
                {/*        style={{ minWidth: '85px' }} */}
                {/*        onClick={onConfirm} */}
                {/*        className="typical-button"*/}
                {/*    >*/}
                {/*        Yes*/}
                {/*    </Button>*/}
                {/*}*/}
            </ModalFooter>
        </Modal>
    );
};

export default DeleteUserModal;